"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ExpandableMenuItemTitleClamp = ({
  title,
  collapsed,
  isOpen,
  children,
  ...other
}) => {
  const [displayTooltip, setDisplayTooltip] = (0, _react.useState)(false);
  const onClamp = () => {
    setDisplayTooltip(true);
  };
  return _react.default.createElement("div", other, _react.default.createElement(_styles.MenuItemTitleClamp, {
    text: title,
    $collapsed: collapsed,
    onClamp: onClamp,
    lines: 1
  }), displayTooltip && children);
};
var _default = exports.default = ExpandableMenuItemTitleClamp;